import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { ProtectedRoute } from './ProtectedRoute';
import { Layout } from './Layout';
import { Login } from './Login';
import { Songs } from './Songs';
import { SongNotes } from './SongNotes';
import { Calendar } from './Calendar';
import { Equipment } from './Equipment';
import { Gigs } from './Gigs';
import { Contacts } from './Contacts';
import { Messages } from './Messages';
import { Settings } from './Settings';
import { Logs } from './Logs';
import './App.css';

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                        <Route index element={<Songs />} />
                        <Route path="songs/:id/notes" element={<SongNotes />} />
                        <Route path="calendar" element={<Calendar />} />
                        <Route path="equipment" element={<Equipment />} />
                        <Route path="gigs" element={<Gigs />} />
                        <Route path="contacts" element={<Contacts />} />
                        <Route path="messages" element={<Messages />} />
                        <Route path="settings" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
                        <Route path="logs" element={<ProtectedRoute adminOnly><Logs /></ProtectedRoute>} />
                    </Route>
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
